<template>
  <div>
    <Detial />
  </div>
</template>

<script>
import Detial from "@/components/class/pay/detial";
export default {
  components: {
    Detial,
  },
  data() {
    return {};
  },
  created() {
    if (localStorage.getItem("setToken") == null) {
      this.goLogin();
    }
  },
};
</script>

<style scoped>
</style>